import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";

import PATHS from "../../Routes/paths";
import { getAlerts, getRoutes } from "../../APIs";
import { RideMap } from "../../Components/Molecules";
import { StoreContext } from "../../Library/contexts";
import { computeTLStats } from "../../Library/geodist";
import { ReactTable } from "../../Components/Molecules";
import { jsonToCSVConvertor } from "../../Library/jsonUtils";
import { ROUTE_STATS_HEADERS } from "../../Library/tableHeaders";
import { Button, IconButton, Spinner, Tooltip } from "@chakra-ui/react";
import { ArrowRightIcon, DownloadIcon } from "../../Assets/images/svgs";
import { GEOFENCE_NOTIFICATION_TYPE, GEOFENCE_TRIGGER_TYPE, ONE_DAY_MS } from "../../Library/constants";
import { Breadcrumb, DatePickerInput, Select, Title } from "../../Components/Atoms";
import { formatSecondsToHHMMSS, getISODate, getLocalisedDate, getLocalisedTime } from "../../Library/datetime";

const ViewRouteStats = () => {
  const [ triggers, setTriggers ] = useState([]);
  const [ routeSelected, setRouteSelected ] = useState(null);

  const [ gfTimelineEvents, setGfTimelineEvents ] = useState([]);

  const [ vehOptions, setVehOptions ] = useState([]);
  const [ userVehiclesMap, setUserVehiclesMap ] = useState(null);
  const [ selectedVehicleId, setSelectedVehicleId ] = useState(0);

  const [ fromDate, setFromDate ] = useState(0);
  const [ toDate, setToDate ] = useState(0);

  const [ stats, setStats ] = useState([]);
  const [ mapCenter, setMapCenter ] = useState({});
  const [ latestPing, setLatestPing ] = useState({});

  const [ error, setError ] = useState(0);
  const [ showLoader, setShowLoader ] = useState(false);

  const [ timePickerError, setTimePickerError ] = useState("");

  const [ showExistingGeofences, setShowExistingGeofences ] = useState(false);

  const { userVehicles, allVehicleRoutes, setAllVehicleRoutes, routesGeofenceMap, setRoutesGeofenceMap, routeTriggers, allGeofences, setAllGeofences } = useContext(StoreContext);

  const userVehMap = useRef({});
  const geofenceMap = useRef(routesGeofenceMap || {});

  const locEvents = useRef([]);
  const tlEvents = useRef([]);
  const geofenceTlEvents = useRef([]);

  const fromDateRef = useRef(0);
  const toDateRef = useRef(0);

  const enteredTriggerIds = useRef(new Set());
  const stopWiseRouteDataRef = useRef([]);

  const completeRouteTlEvents = useRef([]);
  const completeTriggerData = useRef([]);
  const completeLocEvents = useRef([]);

  const routeCompletionData = useRef([]);

  const navigate = useNavigate();

  const url = useMemo(() => new URL(window.location), []);
  const searchParams = useMemo(() => new URLSearchParams(url.search), [ url ]);
  const routeId = useMemo(() => searchParams.get("idx"), [ searchParams ]);

  const breadcrumbPaths = [
    { idx: 1, name: "View Routes", link: PATHS.VIEW_ROUTES },
    { idx: 1, name: "View Route Stats", isCurrentPage: true },
  ];

  const handleTimelineEvents = useCallback((data) => {
    if (data.ts !== 0) {
      if (data.t === GEOFENCE_NOTIFICATION_TYPE) {
        tlEvents.current.push(data);
        if(data.meta && data.meta.tid) enteredTriggerIds.current.add(data.meta.tid);
      }
    } else {
      let routeLapsArray = [];
      var routeTlEvents = tlEvents.current.sort((a, b) => a.ts - b.ts).filter(event=> routeSelected.trgIds.includes(event.meta.tid));
      completeRouteTlEvents.current = routeTlEvents;
      var lastRouteFenceId = routeSelected.trgIds[routeSelected.trgIds.length - 1];
      var addNewRoute = false;

      let firstFenceId = routeSelected.trgIds[0];
      let secondFenceId = routeSelected.trgIds[1];
      let lastSecondFenceId = routeSelected.trgIds[routeSelected.trgIds.length - 2];
      let lastFenceId = routeSelected.trgIds[routeSelected.trgIds.length - 1];
      let routeCompletionArray = [];
      let lapInProgress = false;

      for(var i = 0; i < routeTlEvents.length; i++){
        var event = routeTlEvents[i];

        if (event && event.meta && event.meta.tid) {

          if (event.meta.tid === firstFenceId || event.meta.tid === secondFenceId) {
            let llap = routeCompletionArray[routeCompletionArray.length - 1];

            if (event.meta.tid === firstFenceId && llap && !llap.end && llap.start && llap.start.tid === secondFenceId) {
              llap.start = {ts: event.ts, tid: event.meta.tid, igf: event.meta.igf}
            } else if (!lapInProgress || (llap && llap.end)) {
              routeCompletionArray.push({start: {ts: event.ts, tid: event.meta.tid, igf: event.meta.igf}});
              lapInProgress = true;
            }
          } else if (event.meta.tid === lastSecondFenceId || event.meta.tid === lastFenceId) {
            if (lapInProgress && routeCompletionArray.length) {
              let currentLap = routeCompletionArray[routeCompletionArray.length - 1];

              if (!currentLap.end) {
                  currentLap.end = {ts: event.ts, tid: event.meta.tid, igf: event.meta.igf};
                  lapInProgress = false;
              }
            } else if (event.meta.tid === lastFenceId) {
              let llap = routeCompletionArray[routeCompletionArray.length - 1];
              if (llap && llap.end &&  llap.end.tid && llap.end.tid === lastSecondFenceId) {
                llap.end = { ts: event.ts, tid: event.meta.tid, igf: event.meta.igf };
              }
            }
          }

          let lastElem = stopWiseRouteDataRef.current[stopWiseRouteDataRef.current.length - 1];
          if (lastElem && lastElem.entry && lastElem.exit) {
            let data = {};
            if (event.meta.igf) {
              data.entry = event.ts;
              data.entid = event.meta.tid;
            } else {
              data.exit = event.ts;
              data.extid = event.meta.tid;
            }

            if (i !== routeTlEvents.length - 1) stopWiseRouteDataRef.current.push(data);
          } else {
            if (!lastElem) stopWiseRouteDataRef.current.push({ [event.meta.igf ? "entry" : "exit"]: event.ts, [event.meta.igf ? "entid" : "extid"]: event.meta.tid })
            else if (!lastElem.entry && lastElem.extid !== event.meta.tid) {
              lastElem["entry"] = event.ts;
              lastElem["entid"] = event.meta.tid;
              stopWiseRouteDataRef.current[stopWiseRouteDataRef.current.length - 1] = lastElem;
              stopWiseRouteDataRef.current.push({ exit: event.ts, extid: event.meta.tid });
            } else if (!lastElem.exit && lastElem.entid !== event.meta.tid) {
              lastElem["exit"] = event.ts;
              lastElem["extid"] = event.meta.tid;
              stopWiseRouteDataRef.current[stopWiseRouteDataRef.current.length - 1] = lastElem;
              stopWiseRouteDataRef.current.push({ entry: event.ts, entid: event.meta.tid });
            }
          }
        }

        var lastLap = routeLapsArray[routeLapsArray.length - 1];
        var routeIndex = routeSelected.trgIds.findIndex(id=> id == event.meta.tid);
        if(!lastLap) routeLapsArray.push({start: {ts: event.ts, tid: event.meta.tid, igf: event.meta.igf, routeIndex}});
        else{
          if(!lastLap.end){
            if(event.meta.tid == lastRouteFenceId || (i == routeTlEvents.length - 1)) lastLap.end = {ts: event.ts, tid: event.meta.tid, igf: event.meta.igf, routeIndex}
          }
          else{
            if(event.meta.tid) lastLap.end = {ts: event.ts, tid: event.meta.tid, igf: event.meta.igf, routeIndex}; //event.meta.tid == lastRouteFenceId for mulitple laps
          }
        }
      }

        if (routeCompletionArray && routeCompletionArray.length === 1 && routeCompletionArray[0] && !routeCompletionArray[0].end) {
          let lastEvent = routeTlEvents[routeTlEvents.length - 1];
          routeCompletionArray[0].end = { ts: lastEvent.ts, tid: lastEvent.meta.tid, igf: lastEvent.meta.igf };
        }

        if (routeCompletionArray && !routeCompletionArray.length && routeTlEvents.length > 1) {
          let firstEvent = routeTlEvents[0];
          let lastEvent = routeTlEvents[routeTlEvents.length - 1];
          routeCompletionArray.push({start: {ts: firstEvent.ts, tid: firstEvent.meta.tid, igf: firstEvent.meta.igf}});
          routeCompletionArray[0].end = { ts: lastEvent.ts, tid: lastEvent.meta.tid, igf: lastEvent.meta.igf };
        }

      if (routeCompletionArray && routeCompletionArray.length) {
        routeCompletionData.current = routeCompletionArray;
        geofenceTlEvents.current = routeCompletionArray;
        setGfTimelineEvents(routeCompletionArray);
      }
    }
  }, [ routeSelected ]);

  useEffect(() => {
    if (!gfTimelineEvents || !gfTimelineEvents.length || !completeRouteTlEvents.current || !completeRouteTlEvents.current.length) return;

    let data = { vid: Number(selectedVehicleId), orphan: false, isWeb: true };
    data.fromTs = completeRouteTlEvents.current[0].ts;
    data.toTs = completeRouteTlEvents.current[completeRouteTlEvents.current.length - 1].ts;

    if (!data.fromTs || !data.toTs) return;
    locEvents.current = [];
    global.UWS.sendRequest({ action: global.EE.EVENT_TYPES.GET_LOC_EVENTS, data: data });
  }, [ gfTimelineEvents ]);

  const removeLocationEventListener = () => {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, handleLocationEvents);
  }

  const addLocationEventListener = () => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, handleLocationEvents);
  }

  const handleLocationEvents = (event) => {
    if (event.ts !== 0) {
      if (event.lat && event.lng && event.ts > (fromDateRef.current / 1000) && event.ts < (toDateRef.current / 1000) && event.ignition && event.spd > 5) {
        locEvents.current.push(event);
        setLatestPing(event);
      }
    } else {
      removeLocationEventListener();
      if (!completeLocEvents.current || !completeLocEvents.current.length) completeLocEvents.current = locEvents.current;
      let statsArray = [];
      let lapStats = [];
      setMapCenter({
        lat: locEvents.current[Math.floor(locEvents.current.length / 2)]?.lat,
        lng: locEvents.current[Math.floor(locEvents.current.length / 2)]?.lng,
      });

      geofenceTlEvents.current.forEach((event, i) => {
        let tlLocEvents = locEvents.current.filter(locEvt => locEvt.ts >= event.start.ts && event.end && locEvt.ts <= event.end.ts).sort((a, b) => a.ts - b.ts);
        statsArray.push({...computeTLStats(tlLocEvents), ...event, count: i + 1});
      });

      routeCompletionData.current.forEach(event => {
        let tlLocEvents = locEvents.current.filter(locEvt => locEvt.ts >= event.start.ts && event.end && locEvt.ts <= event.end.ts).sort((a, b) => a.ts - b.ts);
        lapStats.push({...computeTLStats(tlLocEvents), ...event});
      });

      let totalDist = 0;
      lapStats.forEach(a => {
        totalDist += a.dst;
      });

      let endAt = stopWiseRouteDataRef.current[stopWiseRouteDataRef.current.length - 1];
      if (!endAt.entry || !endAt.exit) stopWiseRouteDataRef.current.pop();

      stopWiseRouteDataRef.current = stopWiseRouteDataRef.current.map(data => {
        const isEndFirst = data.exit < data.entry;

        const stopWiseLocEvents = locEvents.current
          .filter(evt =>
            isEndFirst
              ? evt.ts >= data.exit && evt.ts <= data.entry
              : evt.ts >= data.entry && evt.ts <= data.exit
          )
          .sort((a, b) => a.ts - b.ts);


        if (stopWiseLocEvents.length) {
          return { ...computeTLStats(stopWiseLocEvents), ...data };
        }

        return data;
      });

      if (statsArray && statsArray.length) {
        if (totalDist > 0) statsArray.push({ count: "Total", dst: totalDist });
        let filteredStats = statsArray.filter(stat => stat.dst);
        setStats(filteredStats.map((stat, idx) => { stat.count = idx + 1; return stat; }));
      }
      setShowLoader(false);
    }
  }

  useEffect(() => {
    addLocationEventListener();

    return () => {
      removeLocationEventListener();
    }
  }, []);

  const fetchRoutes = (vehicleMap) => {
    getRoutes((err, data) => {
      if (err) console.error(err);
      else {
        if (data.triggers && data.triggers.length) {
          data.triggers.forEach(fence => {
            geofenceMap.current[fence.idx] = fence;
          });

          setRoutesGeofenceMap(geofenceMap.current);
          completeTriggerData.current = data.triggers;
          setTriggers(completeTriggerData.current);
        }

        if (data.vehRoutes && data.vehRoutes.length) {
          let selectedRoute = {};
          data.vehRoutes.forEach(route => {
            if (route.idx === Number(routeId)) selectedRoute = route;
            let vehicles = route.vids.map(id => vehicleMap.current[id] && vehicleMap.current[id].reg ? vehicleMap.current[id].reg : "").filter(model => model !== "");
            route.vehicles = vehicles;
            let fences = route.trgIds.map(id => geofenceMap.current[id] && geofenceMap.current[id].title ? geofenceMap.current[id].title : "").filter(title => title !== "");
            route.fences = fences;
          });

          if (selectedRoute && selectedRoute.idx) {
            setTriggers(completeTriggerData.current.filter(trigger => selectedRoute.trgIds && selectedRoute.trgIds.includes(trigger.idx)));
            setRouteSelected(selectedRoute);
          }

          setAllVehicleRoutes(data.vehRoutes);
        }
      }
    });
  }

  useEffect(() => {
    if (!routeId || !Number(routeId)) navigate(PATHS.VIEW_ROUTES);

    let allVehicles = userVehicles;
    if (routeSelected && routeSelected.idx) allVehicles = userVehicles.filter(veh => routeSelected.vids.includes(veh.idx));

    let options = []
    allVehicles.forEach(vehicle => {
      userVehMap.current[vehicle.idx] = vehicle;
      options.push({ value: vehicle.idx, label: vehicle.reg || vehicle.mo || "-" })
    });

    setUserVehiclesMap(userVehMap.current);

    setVehOptions(options);
    if (options && options.length === 1) setSelectedVehicleId(options[0].value);
  }, [ userVehicles, routeSelected, routeId, navigate ]);

  useEffect(() => {
    if (userVehiclesMap) {
      if (allVehicleRoutes && allVehicleRoutes.length) {
        if (routeId) {
          let selectedRoute = allVehicleRoutes.find(route => route.idx === Number(routeId));
          if (selectedRoute && selectedRoute.idx) {
            setRouteSelected(selectedRoute);
            if (routeTriggers && routeTriggers.length) {
              let filteredTriggers = routeTriggers.filter(trigger => selectedRoute.trgIds && selectedRoute.trgIds.includes(trigger.idx));
              setTriggers(filteredTriggers);
            }
          }
        }
      } else {
        fetchRoutes({ current: userVehiclesMap });
      }
    }
  }, [ userVehiclesMap, allVehicleRoutes, routeId ]);

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.GET_TL_EVENTS, handleTimelineEvents);
    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.GET_TL_EVENTS, handleTimelineEvents);
    }
  }, [ handleTimelineEvents ]);

  const clearVehicleData = (addListener) => {
    if (addListener) {
      addLocationEventListener();
      setShowLoader(true);
    }

    setGfTimelineEvents([]);
    setStats([]);
    setMapCenter({});
    setLatestPing({});
    enteredTriggerIds.current = new Set();
    locEvents.current = [];
    tlEvents.current = [];
    geofenceTlEvents.current = [];
    stopWiseRouteDataRef.current = [];
  }

  const validateFilters = () => {
    if (!selectedVehicleId) return setError("Please select a vehicle to continue");
    else if (!fromDate) return setError("Please select from date to continue");
    else if (!toDate) return setError("Please select to date to continue");
    else if ((toDate - fromDate) > (3 * ONE_DAY_MS)) return setError("The selected date range cannot exceed 3 days.");

    clearVehicleData(true);
    tlEvents.current = [];
    let request = { action: global.EE.EVENT_TYPES.GET_TL_EVENTS, data: { veh: [{ vid: selectedVehicleId, wts: Math.floor(fromDate/1000), tsFr: Math.floor(fromDate/1000), tsTo: Math.floor(toDate/1000) }] } };
    if (global.UWS && global.UWS.wsConnected) global.UWS.sendRequest(request);
  }

  const tableColumns = useMemo(
    () => Object.values(ROUTE_STATS_HEADERS).map((header) => {
      return {
        Header: header.nm,
        accessor: header.key,
        disableSortBy: !header.sorting,
        Cell:(row) => {
          if (row.column.id === "start.tid" || row.column.id === "end.tid") {
            return geofenceMap.current[row.value] ? geofenceMap.current[row.value].title + `${geofenceMap.current[row.value].desc ? ` (${geofenceMap.current[row.value].desc.trim()})` : ""}` : "-";
          }

          if (row.column.id === "start.ts" || row.column.id === "end.ts") {
            return row.value ? `${getLocalisedDate(row.value * 1000)}, ${getLocalisedTime(row.value * 1000)}` : "-";
          }

          if (row.column.id === "dst") {
            return row.value ? `${(row.value / 1000).toFixed(2)} kms` : "-";
          }

          return row.value;
        }
      }
    })
  , []);

  const handleDateSelection = (value, isToDate) => {
    let time = new Date(value).getTime();

    if (isToDate) {
      toDateRef.current = new Date(time).setHours(23, 59, 59);
      if (toDateRef.current > Date.now()) toDateRef.current = Date.now();
      setToDate(toDateRef.current);
    } else {
      fromDateRef.current = new Date(time).setHours(0, 0, 0, 0);
      setFromDate(fromDateRef.current);

    }

    setError("");
  }

  const handleStopWiseDownload = () => {
    stopWiseRouteDataRef.current.forEach(route => {
      if (route.entid && route.extid) {
        const foundRoute = allVehicleRoutes.find(vehRoute => {
          const trgIds = vehRoute.trgIds;
          let foundEntid = false;
          for (let i = 0; i < trgIds.length; i++) {
            if (trgIds[i] === route.entid) {
              foundEntid = true;
            } else if (foundEntid && trgIds[i] === route.extid) {
              return true;
            }
          }
          return false;
        });

        route.name = foundRoute ? foundRoute.nm : "-";
      }
    });

    var sendToExcel = stopWiseRouteDataRef.current.map(a => Object.assign({}, a)).filter(d=> d.entry !== d.exit);
    sendToExcel.forEach((stop, idx) => {
      let { entry: start, exit: end, entid: stid, extid } = stop;

      if (end < start || !start) {
        [stop.entry, stop.exit] = [end, start];
        [stop.entid, stop.extid] = [extid, stid];
      }

      stop["Sr No"] = idx + 1;
      stop["From"] = (stop.entid && geofenceMap.current[stop.entid] && geofenceMap.current[stop.entid].title) ? geofenceMap.current[stop.entid].title : "-";
      stop["Start Date"] = stop.entry ? getLocalisedDate(stop.entry * 1000, true) : "-";
      stop["Start Time"] = stop.entry ? getLocalisedTime(stop.entry * 1000, true, null, true) : "-";
      stop["To"] = (stop.extid && geofenceMap.current[stop.extid] && geofenceMap.current[stop.extid].title) ? geofenceMap.current[stop.extid].title : "-";
      stop["End Date"] = stop.exit ? getLocalisedDate(stop.exit * 1000, true) : "-";
      stop["End Time"] = stop.exit ? getLocalisedTime(stop.exit * 1000, true, null, true) : "-";
      stop["Route Name"] = stop.name;
      stop["Distance (kms)"] = stop.dst ? (stop.dst / 1000).toFixed(2) : "-";
      stop["Runnig Time (hh:mm:ss)"] = stop.dur ? formatSecondsToHHMMSS((stop.dur).toFixed(2)) : "-";
      stop["Idle Time (hh:mm:ss)"] = stop.entry && stop.exit && stop.dur ? formatSecondsToHHMMSS(Number((stop.exit - stop.entry) - stop.dur)) : "-";
    });

    var sendData = sendToExcel.map(function (exceldata) {
      var args = "Sr No, From, Start Date, Start Time, To, End Date, End Time, Route Name, Distance (kms), Runnig Time (hh:mm:ss), Idle Time (hh:mm:ss)";
      var filteredData = args.split(",").reduce((mem, arg) => {
        arg = arg.trim();
        mem[arg] = exceldata[arg];
        return mem;
      }, {});
      return filteredData;
    });
    if (sendData.length) jsonToCSVConvertor(sendData, "", true, "Route_Stops_" + Date.now(), false);
  }

  const handleTimeFilter = (from, to) => {
    setTimePickerError("");
    from = from / 1000;
    to = to / 1000;

    locEvents.current = [];
    locEvents.current = completeLocEvents.current.filter(ping => {
      return (ping.ts >= from && ping.ts <= to);
    });

    if (!locEvents.current || !locEvents.current.length) {
      locEvents.current = completeLocEvents.current;
      setTimePickerError("No ride data available between selected time slots.");
    } else handleLocationEvents({ ts: 0 });
  }

  const handleTimeFilterReset = () => {
    locEvents.current = completeLocEvents.current;
    handleLocationEvents({ ts: 0 });
  }

  const handleVehicleSelect = (val) => {
    setSelectedVehicleId(val);
    setError("");
  }

  const addRouteIdentifierInGeofence = (geofences) => {
    return geofences.map(trigger => {
      let isGeofenceInRoute = routeSelected.trgIds.includes(trigger.idx);
      if (isGeofenceInRoute) trigger.route = true;
      else if (trigger.route) delete trigger.route;

      return trigger;
    });
  }

  useEffect(() => {
    if (!routeSelected || !routeSelected.idx) return;

    if (!allGeofences || !allGeofences.length) {
      getAlerts(GEOFENCE_TRIGGER_TYPE, (err, success) => {
        if (err)console.error(err);
        else {
          if (routeSelected && routeSelected.trgIds && routeSelected.trgIds.length) success = addRouteIdentifierInGeofence(success);
          setAllGeofences(success);
        }
      });
    } else  {
      let geofences = [];
      if (routeSelected && routeSelected.trgIds && routeSelected.trgIds.length) geofences = addRouteIdentifierInGeofence(allGeofences);
      if (geofences.length) setAllGeofences(geofences);
    }
  }, [ routeSelected ]);


  return (
    <section className="panel-main view-routes">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className="routes-page">
        <>
          <div className="filters-container">
            <Select
              options={vehOptions}
              onChange={handleVehicleSelect}
              defaultOption={"Select Vehicles"}
              menuButtonClass={"select-vehicle-dropdown"}
              selected={selectedVehicleId}
            />
            <div className="picker-container">
              <DatePickerInput inputCover={"from-input-cover"} DatepickerClassName={"from-date-picker"} label={"From"} onChange={(val) => handleDateSelection(val)} />
              <DatePickerInput maxDate={getISODate()} inputCover={"to-input-cover"} DatepickerClassName={"to-date-picker"} label={"To"} onChange={(val) => handleDateSelection(val, true)} />
            </div>
            <Button onClick={validateFilters} className="apply-filters-btn">Apply</Button>
            {/* <Button onClick={() => {setRouteSelected(null); clearVehicleData(); navigate(PATHS.VIEW_ROUTES)}} className="change-route-btn">Change Route</Button> */}
            <p className="filters-error-msg">{error || ""}</p>
          </div>
          {stats && stats.length ? <div className="route-stat-card">
            <div className="route-stats-header">
              <Title fixed>Route Stats</Title>
              <Tooltip label="Download">
                <IconButton
                  icon={<DownloadIcon />}
                  onClick={handleStopWiseDownload}
                />
              </Tooltip>
            </div>

            <div className="route-stats-label-container">
              <label className="route-card-label">
                Title:
                <p>{routeSelected.nm}</p>
              </label>
              <label className="route-card-label">
                Vehicle:
                <p>{(userVehMap.current[selectedVehicleId] && userVehMap.current[selectedVehicleId].reg) ? `${userVehMap.current[selectedVehicleId].reg} ${userVehMap.current[selectedVehicleId].mo ? `(${userVehMap.current[selectedVehicleId].mo})` : ""}` : "-"}</p>
              </label>
              <label className="route-card-label">
                Stops:
                <p className="route-geofences">{routeSelected.trgIds.map((trg, id) => (
                    <React.Fragment key={id}>
                      <span className={enteredTriggerIds.current.has(geofenceMap.current[trg].idx) ? "title-highligthed" : ""}>{geofenceMap.current[trg]?.title || ""}</span>
                      {id !== routeSelected.trgIds.length - 1 ?
                        <ArrowRightIcon className="route-geofences-icon" /> : null}
                    </React.Fragment>
                ))}</p>
              </label>
            </div>

            <div className="route-table-container">
              <ReactTable
                columns={tableColumns}
                showSearch={true}
                data={stats || []}
                pageSize={10}
              />
            </div>
            <div>
              {locEvents.current.length && latestPing.vid ? <RideMap colorLabels={true} route={!!routeSelected} showExistingGfsToggle={true} showExistingGeofences={showExistingGeofences} setShowExistingGeofences={setShowExistingGeofences} vehicleDetails={(selectedVehicleId && userVehMap.current[selectedVehicleId]) ? userVehMap.current[selectedVehicleId] : {}} timePickerErr={timePickerError} handleRideFilter={handleTimeFilter} handleRideFilterReset={handleTimeFilterReset} geofencesToPlot={allGeofences} pathTrail={locEvents.current} mapCenter={mapCenter} loading={false} currentPing={latestPing} /> : null}
            </div>
          </div> : (showLoader ? <Spinner className="routes-loader" size={"lg"} /> : "")}
        </>
      </div>
    </section>
  )
}

export default ViewRouteStats
